module.exports = __webpack_public_path__ + "static/media/2025-AFL-Origin-Guernsey-Giveaway-Logged-In.f7ac1337.jpg";